import { useState } from 'react';
import type { User } from '../api/types';
import { ActivityDot } from '../features/presence/ActivityPresence';
import { useStudioPresence } from '../features/presence/StudioPresence';

const SWATCHES = ['#3269d6', '#7a55c5', '#ce5c7b', '#198b70', '#bd6a2b', '#51627f'];

function initials(label: string): string {
  return label
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('');
}

export function Avatar({
  user,
  label,
  size = 'medium',
  presenceUserId,
}: {
  user?: User | null;
  label?: string;
  size?: 'small' | 'medium' | 'large';
  presenceUserId?: number;
}) {
  const text = user?.initial || label || '?';
  const color = SWATCHES[(user?.id ?? text.length) % SWATCHES.length];
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const atStudio = useStudioPresence(user?.id ?? presenceUserId);

  if (user || presenceUserId) return (
    <span className={`avatar avatar--${size} studio-avatar-surface${atStudio ? ' is-at-studio' : ''}`}
      title={atStudio ? 'На студии (по отметкам посещаемости)' : undefined} aria-hidden="true">
      {user?.avatar && failedUrl !== user.avatar
        ? <img alt="" className="studio-avatar-content" onError={() => setFailedUrl(user.avatar)} src={user.avatar} />
        : <span className="studio-avatar-content" style={{ backgroundColor: color }}>{initials(text)}</span>}
      <ActivityDot userId={user?.id ?? presenceUserId} />
    </span>
  );

  return (
    <span className={`avatar avatar--${size}`} style={{ backgroundColor: color }} aria-hidden="true">
      {initials(text)}
    </span>
  );
}
